import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import User from 'models/core/user/Model.User';
import Currency from 'models/enums/Currency';
import Model from 'models/Model';
import ContractRefundDealerPaymentControl from 'models/sales/contractRefundDealerPaymentControl/Model.ContractRefundDealerPaymentControl';
import contractRefundInvoiceDeleteApi from './delete/Api.ContractRefundInvoice.Delete';
import contractRefundInvoiceFindApi from './find/Api.ContractRefundInvoice.Find';
import contractRefundInvoiceGenerateInvoiceDocumentApi from './generateInvoiceDocument/Api.ContractRefundInvoice.GenerateInvoiceDocument';
import contractRefundInvoiceListApi from './list/Api.ContractRefundInvoice.List';
import contractRefundInvoiceSaveApi from './save/Api.ContractRefundInvoice.Save';

export default class ContractRefundInvoice
  extends Model<Model.IContractRefundInvoice>({ icon: 'fas-file-invoice-dollar' })
  implements Model.Instance<Model.IContractRefundInvoice>
{
  id: number;
  readonly number: string;

  totalAmount: number = 0;
  totalAmountBeforeTax: number = 0;
  gstHstAmount: number = 0;
  provincialSalesTaxAmount: number = 0;

  currency: string = Currency.CAD;
  paymentMethodCode: string;
  isCancelled: boolean;
  paymentRequestedAtUtc?: string;

  createdAtLocal: string;

  readonly createdAtUtc: string;
  readonly modifiedAtUtc: string;

  createdById?: number;
  createdBy?: User;

  readonly modifiedById?: number;
  readonly modifiedBy?: User;

  contractRefundDealerPaymentControlId: number;
  contractRefundDealerPaymentControl?: ContractRefundDealerPaymentControl;

  readonly invoiceDocumentId?: number;
  readonly invoiceDocument?: MediaFile;

  constructor(
    data: Partial<Model.IContractRefundInvoice> | Utils.FormData<Model.IContractRefundInvoice>,
    language?: Locale.Languages
  ) {
    super(
      {
        contractRefundDealerPaymentControl: ContractRefundDealerPaymentControl,
        invoiceDocument: MediaFile,
        createdBy: User,
        modifiedBy: User,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.number || this.id?.toString(),
    };
  }

  static async find(params: { id: number }) {
    const { payload, ...rest } = await contractRefundInvoiceFindApi(params);
    return {
      ...rest,
      payload: payload && new ContractRefundInvoice(payload),
    };
  }

  static async list(body?: Api.Sales.ContractRefundInvoice.List.IRequest) {
    const { payload, ...rest } = await contractRefundInvoiceListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractRefundInvoice(it)),
        count: payload.count,
      },
    };
  }

  static async save(body: Api.Sales.ContractRefundInvoice.Save.IRequest) {
    return await contractRefundInvoiceSaveApi(body);
  }

  static async delete(params: { id: number }) {
    return await contractRefundInvoiceDeleteApi(params);
  }

  static async generateInvoiceDocument(params: { contractRefundInvoiceId: number }) {
    return await contractRefundInvoiceGenerateInvoiceDocumentApi(params);
  }
}
